import type { BulkUploadRepository } from "../repositories/BulkUploadRepository";

export class DownloadVendorTemplateUseCase {
  constructor(private readonly repository: BulkUploadRepository) {}

  async execute(): Promise<void> {
    await this.repository.downloadVendorTemplate();
  }
}
